import {
    GOOGLE_AUTH_FAILED,
    GOOGLE_AUTH_START,
    GOOGLE_AUTH_SUCCESS,
    GOOGLE_PAGE_TOKEN,
    SAVE_EMAIL_IN_REDUX,
    MICROSOFT_PAGE_LINK
} from "../actionTypes/emailSettings";

export const initialState = {
    isLoading: false,
    token: '',
    userId: null,
    emailData: {},
    pagination: [],
    currentPage: 0,
    totalEmailPerPage: 0,
    microsoftPagination: [],
    microsoftCurrentPage: 0,
    authEmails: []
};

const emailSettings = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_EMAIL_IN_REDUX:
            return {
                ...state,
                emailData: {
                    email: action.data.email,
                    isVerifying: true,
                    valid: false,
                    authToken: '',
                    refreshToken: '',
                    expiresIn: 0
                }
            };

        case GOOGLE_AUTH_START:
            return {
                ...state,
                isLoading: true
            };

        case GOOGLE_AUTH_SUCCESS: {
            const existingIndex = state.authEmails.findIndex(email => email.email === action.data.email);
            const filteredEmails = state.authEmails.filter(email => email.email !== action.data.email);
            const updatedEmails = [
                ...filteredEmails,
                {
                    email: action.data.email,
                    domain: action.data.domain,
                    token: {
                        accessToken: action.data.authToken,
                        expiresIn: action.data.expiresIn
                    }
                }
            ];

            return {
                ...state,
                isLoading: false,
                authEmails: updatedEmails
            };
        }

        case GOOGLE_AUTH_FAILED:
            return {
                ...state,
                isLoading: false
            };

        case GOOGLE_PAGE_TOKEN: {
            const pageClicked = action.data.pageClicked;
            state.totalEmailPerPage = action.data.totalEmailsPerPage

            if (pageClicked === 1) {
                const newPage = state.currentPage + 1;
                const lastToken = state.pagination[state.pagination.length - 1]?.nextPageToken || '';
                return {
                    ...state,
                    currentPage: newPage,
                    pagination: [
                        ...state.pagination,
                        {
                            prevPageToken: lastToken,
                            currentPage: newPage,
                            nextPageToken: action.data.pageToken || ''
                        }
                    ]
                };
            } else if (pageClicked === -1) {
                const newPage = Math.max(state.currentPage - 1, 0);
                return {
                    ...state,
                    currentPage: newPage,
                    pagination: state.pagination.slice(0, -1)
                };
            } else {
                return {
                    ...state,
                    currentPage: 1,
                    pagination: [{
                        prevPageToken: '',
                        currentPage: 1,
                        nextPageToken: action.data.pageToken || ''
                    }],
                    emailData: {}
                };
            }
        }

        case MICROSOFT_PAGE_LINK: {
            const pageClicked = action.data.pageClicked;

            if (pageClicked === 1) {
                const newPage = state.microsoftCurrentPage + 1;
                const lastToken = state.microsoftPagination[state.microsoftPagination.length - 1]?.nextPageToken || '';
                return {
                    ...state,
                    microsoftCurrentPage: newPage,
                    microsoftPagination: [
                        ...state.microsoftPagination,
                        {
                            prevPageToken: lastToken,
                            currentPage: newPage,
                            nextPageToken: action.data.pageLink || ''
                        }
                    ]
                };
            } else if (pageClicked === -1) {
                const newPage = Math.max(state.microsoftCurrentPage - 1, 0);
                return {
                    ...state,
                    microsoftCurrentPage: newPage,
                    microsoftPagination: state.microsoftPagination.slice(0, -1)
                };
            } else {
                return {
                    ...state,
                    microsoftCurrentPage: 1,
                    microsoftPagination: [{
                        prevPageToken: '',
                        currentPage: 1,
                        nextPageToken: action.data.pageLink || ''
                    }],
                    emailData: {}
                };
            }
        }

        default:
            return state;
    }
};

export default emailSettings;
